import * as React from "react";
function SvgChevronRight(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={4}
        d="M9 30l14-14L9 2"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgChevronRight);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
